module.exports = __webpack_public_path__ + "static/media/icon-salud.040c9bc8.svg";